import API, { APIResponse } from '../../../lib/commons/api'
import { WbsItemBasic } from '../../../lib/functions/wbsItem'
import { UserBasic } from '../../../domain/value-object/UserBasicVO'

export interface WbsItemCriticalPathResponse {
  uuid: string
  projectUuid: string
  fromWbsItemUuid: string
  fromProjectPlanUuid: string
  fromDate: string // "YYYY-MM-DD"
  toWbsItemUuid: string
  toProjectPlanUuid: string
  toDate: string // "YYYY-MM-DD"
  color: string | null
  description: string | null
  lockVersion: number
  fromWbsItem: WbsItemBasic
  toWbsItem: WbsItemBasic
  createdAt: number
  createdBy: UserBasic
  updatedAt: number
  updatedBy: UserBasic
}

/** プロジェクト参照値（プロジェクト名解決用） */
export type CriticalPathProjectRef = {
  uuid: string
  code: string
  name: string
  iconUrl?: string
}

/**
 * プログラム側クリティカルパスのレスポンス。
 * projectUuid は持たず、from/to の WbsItem が属するプロジェクト情報を
 * fromProject/toProject（参照値）で保持する。
 */
export type ProgramWbsItemCriticalPathResponse = Omit<
  WbsItemCriticalPathResponse,
  'projectUuid'
> & {
  fromProject: CriticalPathProjectRef | null
  toProject: CriticalPathProjectRef | null
}

export interface CriticalPathDeltaRequest {
  added: {
    uuid: string
    programUuid?: string
    fromWbsItemUuid: string
    fromDate: string
    toWbsItemUuid: string
    toDate: string
    color?: string
    description?: string
  }[]
  edited: {
    uuid: string
    fromDate: string
    toDate: string
    color?: string
    description?: string
  }[]
  deleted: { uuid: string }[]
}

export const getWbsItemCriticalPaths = (): Promise<APIResponse> =>
  API.functional.request(
    'GET',
    '/api/v1/projects/wbs_item_critical_paths',
    undefined
  )

export const getCrossProjectCriticalPaths = (
  projectUuids: string[]
): Promise<APIResponse> =>
  API.functional.request(
    'GET',
    '/api/v1/projects/wbs_item_critical_paths/cross_projects',
    { projectUuids }
  )

export const saveWbsItemCriticalPaths = (
  request: CriticalPathDeltaRequest
): Promise<APIResponse> =>
  API.functional.request(
    'POST',
    '/api/v1/projects/wbs_item_critical_paths/delta/batch',
    request
  )

export const getProgramWbsItemCriticalPaths = (
  programUuid: string
): Promise<APIResponse> =>
  API.functional.request(
    'GET',
    '/api/v1/projects/wbs_item_critical_paths/programs',
    { programUuid }
  )

export type ProgramCriticalPathDeltaRequest = CriticalPathDeltaRequest & {
  programUuid: string
}

export const saveProgramWbsItemCriticalPaths = (
  request: ProgramCriticalPathDeltaRequest
): Promise<APIResponse> =>
  API.functional.request(
    'POST',
    '/api/v1/projects/wbs_item_critical_paths/programs/delta/batch',
    request
  )
